// 应用内cache层 用于直接复用数据
export const CACHE_IOS_STATUS_BAR_HEIGHT = 'CACHE_IOS_STATUS_BAR_HEIGHT';
export const CACHE_WINDOW_HEIGHT = 'CACHE_WINDOW_HEIGHT';
export const CACHE_WINDOW_WIDTH = 'CACHE_WINDOW_WIDTH';
class Cache {
    private cache: {[key: string]: any} = {};

    public Set<T>(key: string, val: T) {
        this.cache[key] = val;
    }

    public Get<T>(key: string): T | undefined {
        return this.cache[key] as T;
    }

    public Delete(key: string) {
        delete this.cache[key];
    }

    public Clear() {
        this.cache = {};
    }
}

const cache = new Cache();
export default cache;
